import styled from 'styled-components'
import { tokens } from 'styling/tokens'

export const DrawerGroupRow = styled.div`
  display: grid;
  grid-template-columns: 12rem 1fr auto;
  align-items: start;
  gap: 1rem;
  padding: 0.75rem 0;

  &:not(:last-child) {
    border-bottom: 1px solid ${tokens.border.hairline};
  }

  @media (max-width: 56rem) {
    grid-template-columns: 1fr;
    gap: 0.5rem;
  }
`

export const DrawerClassName = styled.span`
  font-size: ${tokens.font.body};
  font-weight: 600;
  color: ${tokens.text.primary};
`

export const DrawerChips = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
`

export const DrawerChip = styled.span`
  font-size: ${tokens.font.label};
  font-weight: 600;
  color: ${tokens.text.secondary};
  background: ${tokens.surface.inset};
  border: 1px solid ${tokens.border.hairline};
  border-radius: ${tokens.radius.chip};
  padding: 0.25rem 0.5rem;
  white-space: nowrap;
`

export const DrawerMeta = styled.span`
  font-size: ${tokens.font.micro};
  color: ${tokens.text.muted};
  white-space: nowrap;
`
